function e(t) {
  var o = typeof t;
  return o == "string" || o == "number" || o == "symbol" || o == "boolean" ? t !== "__proto__" : t === null;
}
export {
  e as default
};
